import { actionCreation } from '@anna/anna-ws-utils';

const { generateActionTypes, generateActions, makeActionCreator } = actionCreation;

export const actionTypes = {
  CLEAR_IMAGES: 'CLEAR_IMAGES',
};

export const getImageActionTypes = generateActionTypes('GET_IMAGE');

export const getImageActions = generateActions(
  getImageActionTypes, {
    request: ['id'],
    common: ['id', 'name', 'url'],
    success: ['id', 'src', 'contentType'],
  },
);

export const clearImages = makeActionCreator(actionTypes.CLEAR_IMAGES);
